import { configureStore } from '@reduxjs/toolkit';

import placesReducer from './slices/places-slice';
import appUsersReducer from './slices/app-users-slice';
import dashboardReducer from './slices/dashboard-slice';
import { reportsReducer } from './slices/reports-slice';
import { feedbackReducer } from './slices/feedback-slice';
import adminUsersReducer from './slices/admin-users-slice';
import { publicityReducer } from './slices/publicity-slice';
import enterprisesReducer from './slices/enterprises-slice';
import { exploreDebugReducer } from './slices/explore-debug-slice';
import { communicationsReducer } from './slices/communications-slice';
import { supportTicketsReducer } from './slices/support-tickets-slice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    appUser: appUsersReducer,
    adminUser: adminUsersReducer,
    places: placesReducer,
    enterprises: enterprisesReducer,
    reports: reportsReducer,
    feedback: feedbackReducer,
    supportTickets: supportTicketsReducer,
    communications: communicationsReducer,
    publicity: publicityReducer,
    exploreDebug: exploreDebugReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
